export default "__VITE_ASSET__DOS1XUhJ__"